import { AGENT511, AGENT_511 } from '@rsos/constants/agent511';
import {
  UBER,
  INVISAWEAR,
  APPLE,
  GOOGLE,
  ANI_ALI,
} from '../constants/dataSources';

/**
 * Determines if the source (application) value starts with 'ali_'.
 * @param {Object} location - The 911 event's location.
 * @returns Boolean
 */
export const isSourceAniAli = location =>
  !!(
    location?.application?.startsWith('ali_') ||
    location?.class_of_service_category
  );

/**
 * Interprets the location source (application) value to be used in the 911 event's pane and popup.
 * @param {Object} location - The 911 event's location.
 * @returns String
 */
export const getDataSource = location => {
  const isAniAli = isSourceAniAli(location);

  const classOfService = location?.class_of_service || null;

  let source = '';

  if (location?.application) {
    if (location.application.toLowerCase() === AGENT_511) {
      source = AGENT511;
    } else if (location.application.toLowerCase().includes('uber')) {
      source = UBER;
    } else if (location.application.toLowerCase().includes('invisawear')) {
      source = INVISAWEAR;
    } else if (location.application.toLowerCase() === 'ios') {
      source = APPLE;
    } else if (location.application.toLowerCase() === 'els') {
      source = GOOGLE;
    } else if (isAniAli) {
      source = `${ANI_ALI} (${classOfService ? classOfService : 'Landline'})`;
    }
  }

  return source;
};

export const formatValue = value => {
  return parseFloat(value).toFixed(7).replace(/0+$/, '').replace(/[.]+$/, '');
};

export const convertUnixTimeStamp = timeStamp => {
  let date = new Date(timeStamp);
  let currentTime = new Date(timeStamp).toLocaleTimeString();
  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  let yy = date.getFullYear();

  return `${mm}/${dd}/${yy} | ${currentTime}`;
};

/**
 * @param {Object} params - key value pair in query param
 */
export const paramParser = params => {
  const paramsStr = Object.keys(params).reduce((acc, key, i) => {
    if (
      params[key] === undefined ||
      params[key] === null ||
      typeof params[key] === 'object'
    )
      return acc;
    const n = i ? '&' : '';
    const str = params[key].toString();
    return acc + `${n + key}=${str}`;
  }, '');
  return paramsStr;
};
